// constants.js
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// pubsub.js
let subscribers = {};
function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }
  subscribers[eventName] = [...subscribers[eventName], callback];
  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}
function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}

// details-disclosure.js
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }
  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }
  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}
customElements.define('details-disclosure', DetailsDisclosure);
class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }
  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}
customElements.define('header-menu', HeaderMenu);

// details-modal.js
class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);

// search-form.js
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

// puainta.min.js
const a0_0x3e1ce0=a0_0x3414;function a0_0x37ad(){const _0x348395=['method','substring','sort','language','generateSign','signal','1517092HgKkJE','arrayBufferToHex','99AQhLfQ','map','NETWORK_ERROR','subtle','REQUEST_FAILED','/Shopify/User/syncStatus','970690nqwxCc','get','padStart','userAgent','calculate','9751105Hjnuly','timeout','createSecureData','sign\x20fail','message','sendSecureRequest','deviceInfo','AbortError','include','1.0','importKey','name','log','6900684mYpaVD','platform','fetchWithTimeout','POST','请求失败，请稍后重试','请求失败:','toString','error','toUpperCase','requestInterceptor','toLowerCase','ntl','69704SVsIHY','now','responseInterceptor','1411986Qmxunp','请求超时，请稍后重试','stringify','https://puainta.com','prepareSignString','application/json','apiBaseUrl','handleError','encode','5153493EPDZMk','config','setResponseInterceptor','join','GET','post','4PbzRvx','random','fromCharCode','generateRequestId','localStorage','onLine'];a0_0x37ad=function(){return _0x348395;};return a0_0x37ad();}(function(_0x45191c,_0x2b4d58){const _0x265276=a0_0x3414,_0x479ff0=_0x45191c();while(!![]){try{const _0xd4986e=-parseInt(_0x265276(0xe5))/0x1+parseInt(_0x265276(0xca))/0x2+parseInt(_0x265276(0xd3))/0x3*(parseInt(_0x265276(0xd9))/0x4)+-parseInt(_0x265276(0xed))/0x5+-parseInt(_0x265276(0xff))/0x6+parseInt(_0x265276(0xf2))/0x7+parseInt(_0x265276(0x10b))/0x8*(-parseInt(_0x265276(0xe7))/0x9);if(_0xd4986e===_0x2b4d58)break;else _0x479ff0['push'](_0x479ff0['shift']());}catch(_0x43032c){_0x479ff0['push'](_0x479ff0['shift']());}}}(a0_0x37ad,0xd1e04));function a0_0x3414(_0x475c7d,_0xfbb3e3){_0x475c7d=_0x475c7d-0xc9;const _0x37ad46=a0_0x37ad();let _0x3414ed=_0x37ad46[_0x475c7d];return _0x3414ed;}class Sner{static async[a0_0x3e1ce0(0xe3)](_0x23024a,_0x21601e){const _0x5cb9d7=a0_0x3e1ce0;!_0x21601e&&(_0x21601e=0x1);try{const _0x1c9a1c=this[_0x5cb9d7(0xce)](_0x23024a);return await this[_0x5cb9d7(0xf1)](_0x1c9a1c,_0x21601e);}catch(_0x1db021){console[_0x5cb9d7(0xfe)](_0x5cb9d7(0xf5),_0x1db021);}}static[a0_0x3e1ce0(0xce)](_0x245657){const _0x58d548=a0_0x3e1ce0,_0x4bdcac={..._0x245657};delete _0x4bdcac['sign'];const _0x3f44d6=Object['keys'](_0x4bdcac)[_0x58d548(0xe1)](),_0x7db8b3=_0x3f44d6[_0x58d548(0xe8)](_0x56e269=>{const _0x359f1c=_0x4bdcac[_0x56e269];return _0x56e269+'='+String(_0x359f1c);});return _0x7db8b3[_0x58d548(0xd6)]('&');}static[a0_0x3e1ce0(0x10a)](_0x591426){const _0x533f46=a0_0x3e1ce0;if(_0x591426<0x1||_0x591426>0x1a)return'';return String[_0x533f46(0xdb)](0x40+_0x591426);}static async[a0_0x3e1ce0(0xf1)](_0x308f5a,_0x272a94){const _0x4a9b19=a0_0x3e1ce0,_0x201a1e=(this[_0x4a9b19(0x10a)](0x8)+this[_0x4a9b19(0x10a)](0xd)+this[_0x4a9b19(0x10a)](0x1)+this['ntl'](0x3))[_0x4a9b19(0x107)](),_0x2e5290='S'+(this[_0x4a9b19(0x10a)](0x8)+this[_0x4a9b19(0x10a)](0x1))[_0x4a9b19(0x107)]()+'-'+'2'+'5'+(0xc0/0x20)['toString'](),_0x27e381=new TextEncoder(),_0x1a3114=await crypto[_0x4a9b19(0xea)][_0x4a9b19(0xfc)]('raw',_0x27e381[_0x4a9b19(0xd2)](_0x272a94),{'name':_0x201a1e,'hash':_0x2e5290},![],[(this['ntl'](0x13)+this['ntl'](0x9)+this['ntl'](0x7))[_0x4a9b19(0x109)]()+'n']),_0xa84210=await crypto['subtle']['sign'](_0x201a1e,_0x1a3114,_0x27e381[_0x4a9b19(0xd2)](_0x308f5a));return this[_0x4a9b19(0xe6)](_0xa84210);}static['arrayBufferToHex'](_0x463215){const _0x553f50=a0_0x3e1ce0,_0xacf86e=new Uint8Array(_0x463215);return Array['from'](_0xacf86e)['map'](_0x3792b5=>_0x3792b5[_0x553f50(0x105)](0x10)[_0x553f50(0xef)](0x2,'0'))[_0x553f50(0xd6)]('');}static[a0_0x3e1ce0(0xf4)](_0x4ab295){const _0x5766ff=a0_0x3e1ce0;return{..._0x4ab295,'timestamp':Date[_0x5766ff(0x10c)](),'nonce':this['generateNonce'](),'version':_0x5766ff(0xfb)};}static['generateNonce'](){const _0x3ba5cf=a0_0x3e1ce0;return Math[_0x3ba5cf(0xda)]()['toString'](0x24)[_0x3ba5cf(0xe0)](0x2,0xf)+Math[_0x3ba5cf(0xda)]()[_0x3ba5cf(0x105)](0x24)[_0x3ba5cf(0xe0)](0x2,0xf);}}class ApiClient{constructor(_0x32540e={}){const _0x5e7869=a0_0x3e1ce0;this[_0x5e7869(0xd4)]={'apiBaseUrl':_0x32540e[_0x5e7869(0xd0)]||'','timeout':_0x32540e[_0x5e7869(0xf3)]||0x7530,..._0x32540e},this['requestInterceptor']=null,this['responseInterceptor']=null;}['setRequestInterceptor'](_0x3ef1b5){const _0x47c55e=a0_0x3e1ce0;this[_0x47c55e(0x108)]=_0x3ef1b5;}['setResponseInterceptor'](_0x307663){const _0x465e27=a0_0x3e1ce0;this[_0x465e27(0xc9)]=_0x307663;}async['sendSecureRequest'](_0x70df0,_0x27d8b2,_0x46ec01={},_0x4cabea){const _0xb33eb4=a0_0x3e1ce0;try{const _0x272155=Sner[_0xb33eb4(0xf4)](_0x27d8b2),_0x3c687d=await Sner[_0xb33eb4(0xe3)](_0x272155,_0x4cabea),_0x5aa71a={..._0x272155,'sign':_0x3c687d};this[_0xb33eb4(0x108)]&&await this['requestInterceptor'](_0x5aa71a);const _0x48963e=await this[_0xb33eb4(0x101)](''+this[_0xb33eb4(0xd4)][_0xb33eb4(0xd0)]+_0x70df0,{'method':_0x46ec01[_0xb33eb4(0xdf)]||_0xb33eb4(0x102),'headers':{'Content-Type':_0xb33eb4(0xcf),'X-Request-ID':this[_0xb33eb4(0xdc)](),..._0x46ec01['headers']},'body':JSON[_0xb33eb4(0xcc)](_0x5aa71a)},this[_0xb33eb4(0xd4)][_0xb33eb4(0xf3)]);return _0x48963e;}catch(_0x214a4f){console['error']('API\x20request\x20fail:',_0x214a4f);throw this[_0xb33eb4(0xd1)](_0x214a4f);}}async[a0_0x3e1ce0(0x101)](_0x4aafaa,_0x1d9153,_0x5554db){const _0x5281b2=a0_0x3e1ce0,_0x303814=new AbortController(),_0x5368c6=setTimeout(()=>_0x303814['abort'](),_0x5554db);try{const _0x377375=await fetch(_0x4aafaa,{..._0x1d9153,'credentials':_0x5281b2(0xfa),'signal':_0x303814[_0x5281b2(0xe4)]});return clearTimeout(_0x5368c6),_0x377375;}catch(_0x536d3e){clearTimeout(_0x5368c6);throw _0x536d3e;}}[a0_0x3e1ce0(0xdc)](){const _0x11c5a5=a0_0x3e1ce0;return'req_'+Date[_0x11c5a5(0x10c)]()+'_'+Math[_0x11c5a5(0xda)]()[_0x11c5a5(0x105)](0x24)['substr'](0x2,0x9);}[a0_0x3e1ce0(0xd1)](_0x58afaa){const _0x219194=a0_0x3e1ce0;if(_0x58afaa[_0x219194(0xfd)]===_0x219194(0xf9))return{'code':'TIMEOUT','message':_0x219194(0xcb)};if(!navigator[_0x219194(0xde)])return{'code':_0x219194(0xe9),'message':'网络连接失败，请检查网络设置'};return{'code':_0x219194(0xeb),'message':_0x58afaa[_0x219194(0xf6)]||_0x219194(0x103)};}async[a0_0x3e1ce0(0xd8)](_0x334b06,_0x29af5c,_0x487d2a={},_0x1b744c){const _0x27bb0d=a0_0x3e1ce0;return this[_0x27bb0d(0xf7)](_0x334b06,_0x29af5c,{..._0x487d2a,'method':_0x27bb0d(0x102)},_0x1b744c);}async[a0_0x3e1ce0(0xee)](_0x33b4a4,_0x2d4556={},_0xbc1fff={},_0x42e3a0){const _0x28cb18=a0_0x3e1ce0,_0x317267=new URLSearchParams(_0x2d4556)[_0x28cb18(0x105)](),_0x56a0ea=_0x317267?_0x33b4a4+'?'+_0x317267:_0x33b4a4;return this[_0x28cb18(0xf7)](_0x56a0ea,{},{..._0xbc1fff,'method':_0x28cb18(0xd7)},_0x42e3a0);}}const apiClient=new ApiClient({'apiBaseUrl':a0_0x3e1ce0(0xcd),'timeout':0x7530});apiClient['setRequestInterceptor'](async _0x27b966=>{const _0x3bfd0f=a0_0x3e1ce0;_0x27b966[_0x3bfd0f(0xf8)]={'platform':navigator[_0x3bfd0f(0x100)],'userAgent':navigator[_0x3bfd0f(0xf0)],'language':navigator[_0x3bfd0f(0xe2)]};}),apiClient[a0_0x3e1ce0(0xd5)](async _0x19f4e8=>{return _0x19f4e8;});async function submitUserInfo(_0x41b786){const _0x3ae275=a0_0x3e1ce0;try{const _0x132b1e=await apiClient[_0x3ae275(0xd8)](_0x3ae275(0xec),_0x41b786,{'headers':{'token':window[_0x3ae275(0xdd)]['getItem']('token')}},_0x41b786['sec']);return _0x132b1e;}catch(_0x60e3e7){console[_0x3ae275(0x106)](_0x3ae275(0x104),_0x60e3e7);throw _0x60e3e7;}}